var _style;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1792 1792",
    style: {
      enableBackground: "new 0 0 1792 1792"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);stroke:url(#SVGID_00000080186234091645969810000007565664171206787985_);stroke-miterlimit:10;}\r\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 47.6652,
    y1: 893.89,
    x2: 1713.0293,
    y2: 893.89,
    gradientTransform: "matrix(1 0 0 -1 0 1789.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B9EE0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1831,
    style: {
      stopColor: "#7EB6FF",
      stopOpacity: 0.73
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4047,
    style: {
      stopColor: "#7EB6FF",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6B9EE0"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000168084758918534440800000008908125901451850150_",
    gradientUnits: "userSpaceOnUse",
    x1: 47.1652,
    y1: 896,
    x2: 1713.5293,
    y2: 896
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1D1D1B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)",
      stroke: "url(#SVGID_00000168084758918534440800000008908125901451850150_)",
      strokeMiterlimit: 10
    },
    d: " M1687.2,478c26.7,38,32.7,81,18,129l-275,906c-12.7,42.7-38.2,78.5-76.5,107.5s-79.2,43.5-122.5,43.5h-923 c-51.3,0-100.8-17.8-148.5-53.5S78.9,1531,60.2,1479c-16-44.7-16.7-87-2-127c0-2.7,1-11.7,3-27s3.3-27.7,4-37 c0.7-5.3-0.3-12.5-3-21.5c-2.7-9-3.7-15.5-3-19.5c1.3-7.3,4-14.3,8-21s9.5-14.5,16.5-23.5s12.5-16.8,16.5-23.5 c15.3-25.3,30.3-55.8,45-91.5s24.7-66.2,30-91.5c2-6.7,2.2-16.7,0.5-30s-1.8-22.7-0.5-28c2-7.3,7.7-16.7,17-28s15-19,17-23 c14-24,28-54.7,42-92c14-37.3,22.3-67.3,25-90c0.7-6-0.2-16.7-2.5-32s-2.2-24.7,0.5-28c2.7-8.7,10-18.8,22-30.5s19.3-19.2,22-22.5 c12.7-17.3,26.8-45.5,42.5-84.5s24.8-71.2,27.5-96.5c0.7-5.3-0.3-13.8-3-25.5s-3.3-20.5-2-26.5c1.3-5.3,4.3-11.3,9-18 s10.7-14.3,18-23s13-15.7,17-21c5.3-8,10.8-18.2,16.5-30.5c5.7-12.3,10.7-24,15-35s9.7-23,16-36s12.8-23.7,19.5-32 s15.5-16.2,26.5-23.5s23-11.2,36-11.5s28.8,1.5,47.5,5.5l-1,3c25.3-6,42.3-9,51-9h761c49.3,0,87.3,18.7,114,56s32.7,80.7,18,130 l-274,906c-24,79.3-47.8,130.5-71.5,153.5s-66.5,34.5-128.5,34.5h-869c-18,0-30.7,5-38,15c-7.3,10.7-7.7,25-1,43 c16,46.7,64,70,144,70h923c19.3,0,38-5.2,56-15.5s29.7-24.2,35-41.5l300-987c4.7-14.7,6.3-33.7,5-57 C1653.5,445,1673.2,459.3,1687.2,478z M623.2,480c-2.7,8.7-2,16.2,2,22.5s10.7,9.5,20,9.5h608c8.7,0,17.2-3.2,25.5-9.5 s13.8-13.8,16.5-22.5l21-64c2.7-8.7,2-16.2-2-22.5s-10.7-9.5-20-9.5h-608c-8.7,0-17.2,3.2-25.5,9.5s-13.8,13.8-16.5,22.5L623.2,480z  M540.2,736c-2.7,8.7-2,16.2,2,22.5s10.7,9.5,20,9.5h608c8.7,0,17.2-3.2,25.5-9.5s13.8-13.8,16.5-22.5l21-64c2.7-8.7,2-16.2-2-22.5 s-10.7-9.5-20-9.5h-608c-8.7,0-17.2,3.2-25.5,9.5s-13.8,13.8-16.5,22.5L540.2,736z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookBlue);
export default __webpack_public_path__ + "static/media/book_blue.ebfd9f34af3153212fd3b0c03f7963a6.svg";
export { ForwardRef as ReactComponent };